import React, { useEffect } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ArticleFromServer from '../../components/ArticleFromServer/ArticleFromServer';
import './PageArticle.scss';
import './PageArticle-media.scss';

import { Props } from './interfaces';
import Content from '../../components/Content/Content';
import { ServiceData } from '../../redux/services/ServiceRedux';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Page404 from '../404/404';
import { ISeo } from '../../services/Interfaces';
import { SchemaJsonArticle } from './Functions';

const PageArticle = ({
  widthWindow,
  state404,
  article
}: Props) => {
  const { title, date, content_text, title_seo, description_seo, image } = article;

  const seoData: ISeo = {title: title_seo, description: description_seo}
  seoData.og = {
    image: article.image
  }

  if (state404) {
    return <Page404 />;
  }

  return (
    <div className="page-article">
      <SchemaJsonArticle title={title} image={image} text={content_text} />

      <Content
        width={widthWindow > 720 ? '738px' : ''}
        block={
          <div className="page-article__container">
            <Breadcrumbs title={title} />
            <h1 className="page-article__title">{title}</h1>
            <p className="page-article__date">{date}</p>

            <ArticleFromServer item={content_text} />
          </div>
        }
      />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageArticle));
